import i18n from "@microdoing/shared/i18n";
import React from "react";
import { StyleSheet } from "react-native";
import { MainText, MainTitle, Box } from "app/components/common";
import FastImage from "react-native-fast-image";
import normalize from "app/utils/normalize";

const FINISHED_COACHING_PICTURE = require("../../../assets/images/finished-coaching.png");

const styles = StyleSheet.create({
  image: {
    height: normalize(100),
    width: normalize(150),
  },
});

const FinishedCoaching = ({}) => {
  return (
    <Box
      marginTop="l"
      marginBottom="m"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      <FastImage
        style={styles.image}
        resizeMode="contain"
        source={FINISHED_COACHING_PICTURE}
      />
      <MainTitle marginTop="sm" textAlign="center">
        {i18n.t("coaching-finished")}
      </MainTitle>
      <MainText marginTop="s" textAlign="center">
        {i18n.t("see-coaching-results")}
      </MainText>
    </Box>
  );
};

export default FinishedCoaching;
